// extracted by mini-css-extract-plugin
module.exports = {"navigation":"MainHeader_navigation_2nMxa","searchBar":"MainHeader_searchBar_2XGkY"};